import { ChangeDetectionStrategy, Component } from '@angular/core';

import { IconComponent } from '../icon/icon.component';

/**
 * Decorative brand accent — the nested EchoBlue hexagon on a 160×100 tile — for empty and
 * placeholder areas. Purely visual, hidden from assistive technology.
 */
@Component({
  selector: 'esn-accent-hexagon',
  imports: [IconComponent],
  templateUrl: './accent-hexagon.component.html',
  styles: [
    ':host { display: inline-flex; align-items: center; justify-content: center; width: 160px; height: 100px; border-radius: var(--esn-radius-sm); color: var(--esn-echo-blue); }',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { 'aria-hidden': 'true' },
})
export class AccentHexagonComponent {}
